import { render, staticRenderFns } from "./workOrder.vue?vue&type=template&id=35865791&scoped=true&"
import script from "./workOrder.vue?vue&type=script&lang=ts&"
export * from "./workOrder.vue?vue&type=script&lang=ts&"
import style0 from "./workOrder.vue?vue&type=style&index=0&id=35865791&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35865791",
  null
  
)

export default component.exports